export var initialState = {
  pricingGrid: {
    initialized: false,
    isProduction: false,
    shippingCostPreview: null,
    productPricePreviews: null,
    skuData: null,
    widthOfGrid: '850px',
    widthOfQuantity: '150px',
    priceMode: 'total',
    isSingleSkuEnvironment: true,
    deliveryLocations: {},
    fulfillmentLocations: null,
    skuProductionTime: {},
    initialShippingConfiguration: null,
    isSaveShippingEnabled: false,
    isPivoting: false,
    showToolBar: true,
    toolBarIcons: null,
    budgetRates: null,
    showCompetitivePricing: false,
    productPriceContractsInfo: null,
    selectedTab: 0
  },
  pricingGridLayout: {
    priceMode: 'total',
    rowData: null,
    headers: null,
    currencies: null
  },
  contractsGrid: {
    headers: null,
    rowData: null
  },
  priceExplorerGrid: {
    sellers: {},
    merchants: {},
    selectedRow: undefined,
    selectedColumns: [],
    headers: null,
    rowData: null,
    quantityBreaks: null,
    contractsPerSku: {},
    catalogPriceModelsPerSku: {},
    manufacturingCostModelsPerSku: {},
    loggedSKU: null,
    grossMarginSelections: {
      cost: undefined,
      price: undefined
    },
    hasPermissionForFulfiller: {},
    isLoadingEquivalencies: false,
    pricingVersion: '',
    priceConfigurations: null,
    accountMap: {}
  },
  bulkExport: {
    childOpen: false,
    bsStyle: undefined,
    value: 'pricingGrid',
    disableBulkExportSelection: false,
    showCustomBulkExportModal: false,
    showCustomUploadModal: false,
    showTasksModal: false,
    tasksList: [],
    searchJobsString: undefined,
    loadingJobsData: true,
    jobDeletedStatus: null,
    isExported: true
  },
  customBulkExport: {
    sku: '',
    enabledInputCustomValues: {},
    checked: {},
    openList: {},
    customInput: {},
    possibilitiesSet: undefined,
    originalPossibilitiesSet: null,
    emailSentStatus: null,
    customExportDisabled: false,
    combinationsCount: null
  }
};